import * as types from '@/store/mutation-types';

const mutations = {
  [types.SET_YOUTUBE_SRC](state, p) {
    const drp = p.drp;
    drp.youTubeLink = p.youTubeLink;
  },
  [types.SET_YOUTUBE_AUTOPLAY](state, p) {
    const drp = p.drp;
    drp.autoplay = p.autoplay;
  },
};

const actions = {
  setYoutubeSrc: ({ commit }, payload) => {
    commit(types.SET_YOUTUBE_SRC, payload);
  },
  setYoutubeAutoPlay: ({ commit }, payload) => {
    commit(types.SET_YOUTUBE_AUTOPLAY, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/youtube-video/vuex.js